import { required } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
const textinputStyle = (isEditMode: boolean) => {
  return {
    type: 'body12',
    borderColor: isEditMode ? '#E0E0E0' : 'WHITE',
    labelPaddingBottom: 8,
    borderRadius: isEditMode ? 4 : 0,
    labelFontFamily: 'jiotype-bold',
    fontFamily: 'jiotype-medium',
    labelColor: '#757575',
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
    paddingHorizontal: 8,
    color: 'BLACK_21',
  }
}

export const emGeneralConfigFormData = (isEditMode: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'emGeneralConfig',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'integrationType',
            ComponentName: TextInputNew,
            label: 'Integration type',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'integrationType',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'sodexo',
            ComponentName: TextInputNew,
            label: 'Sodexo',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'sodexo',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'offers',
            ComponentName: TextInputNew,
            label: 'Offers',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'Offers',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'commentsForOffers',
            ComponentName: TextInputNew,
            label: 'Comments for offers (Optional)',
            placeholder: '',
            editable: isEditMode,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'commentsForOffers',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'emiFlag',
            ComponentName: TextInputNew,
            label: 'EMI Flag',
            placeholder: '',
            editable: isEditMode,
            width: '25%',
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'emiFlag',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'tokenisationFlag',
            ComponentName: TextInputNew,
            label: 'Tokenisation flag',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'tokenisationFlag',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'collectLink',
            ComponentName: TextInputNew,
            label: 'Collect link',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'collectLink',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
          {
            fieldName: 'subscription',
            ComponentName: TextInputNew,
            label: 'Subscription',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...textinputStyle(isEditMode),
            width: '25%',
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'subscription',
            onFocusBorderWidth: isEditMode ? 1 : 0,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
